export default {
  area_page: {
    title: 'Online social & dating site for otaku',
    h1: 'Online social & dating site for otaku',
    meta_description:
      '[Online social / meeting events where you can meet Japanese people are posted here] Recommended for Americans looking to meet Japanese people. Machicon Japan, the place to meet people.'
  }
}
